import { useEffect, useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

/** useState that is remembered on this device (e.g. which sections are folded). */
export function usePersisted<T>(key: string, initial: T): [T, (v: T) => void] {
  const [value, setValue] = useState<T>(initial);

  useEffect(() => {
    AsyncStorage.getItem(key)
      .then((raw) => {
        if (raw !== null) setValue(JSON.parse(raw));
      })
      .catch(() => {});
  }, [key]);

  const set = (v: T) => {
    setValue(v);
    AsyncStorage.setItem(key, JSON.stringify(v)).catch(() => {});
  };

  return [value, set];
}
